module.exports = function() {
  return new Worker(__webpack_public_path__ + "b0a425d9b24af8ec53cd.worker.js");
};